<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛项管理</el-breadcrumb-item>
      <el-breadcrumb-item>创建赛项</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入赛事名称"
            v-model="queryInfo.MatchName"
            clearable
            @clear="getCreateList(1)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getCreateList(1)"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showAddCreate">创建赛事</el-button>
          <el-button type="primary" @click="export2Excel()"
            >导出excel</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column
          prop="StartTime"
          label="开始时间"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column
          prop="RegStartTime"
          label="报名开始"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column
          prop="RegEndTime"
          label="报名截止"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column
          prop="ScoStartTime"
          label="评分开始"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column
          prop="ScoEndTime"
          label="评分截止"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column
          prop="EndTime"
          label="结束时间"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditCreate(scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteCreate(scope.row.MatchID)"
              >删除</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="showEditNotice(scope.row)"
              >评审须知</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>

      <!-- 添加 -->
      <el-dialog
        title="添加赛事"
        :visible.sync="addDialogVisible"
        width="30%"
        @close="addresetFields"
      >
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称" prop="MatchName">
            <el-input v-model="addForm.MatchName"></el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="StartTime">
            <el-date-picker
              v-model="addForm.StartTime"
              type="datetime"
              placeholder="选择日期"
              width="100%"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名开始" prop="RegStartTime">
            <el-date-picker
              v-model="addForm.RegStartTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名截至" prop="RegEndTime">
            <el-date-picker
              v-model="addForm.RegEndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评分开始" prop="ScoStartTime">
            <el-date-picker
              v-model="addForm.ScoStartTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评分截至" prop="ScoEndTime">
            <el-date-picker
              v-model="addForm.ScoEndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="EndTime">
            <el-date-picker
              v-model="addForm.EndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addCreate()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改 -->
      <el-dialog
        title="修改赛事"
        :visible.sync="editDialogVisible"
        width="30%"
        @close="editresetFields"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称" prop="MatchName">
            <el-input v-model="editForm.MatchName"></el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="StartTime">
            <el-date-picker
              v-model="editForm.StartTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名开始" prop="RegStartTime">
            <el-date-picker
              v-model="editForm.RegStartTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名截至" prop="RegEndTime">
            <el-date-picker
              v-model="editForm.RegEndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评分开始" prop="ScoStartTime">
            <el-date-picker
              v-model="editForm.ScoStartTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评分截至" prop="ScoEndTime">
            <el-date-picker
              v-model="editForm.ScoEndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="EndTime">
            <el-date-picker
              v-model="editForm.EndTime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 评审须知 -->
      <el-dialog
        title="评审须知"
        :visible.sync="noticeDialogVisible"
        width="30%"
      >
        <el-form ref="noticeFormRef" :model="noticeForm">
          <el-form-item>
            <el-input
              type="textarea"
              v-model="noticeForm.ReviewNotice"
              placeholder="请输入评审须知"
              maxlength="2000"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="noticeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editNotice()">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MatchName: '',
        // 当前页码
        pageNum: 1,
        // 每页显示条数
        pageSize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      addDialogVisible: false,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 评审须知弹框显示状态
      noticeDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      addForm: {
        MatchName: '',
        StartTime: null,
        RegStartTime: null,
        RegEndTime: null,
        ScoStartTime: null,
        ScoEndTime: null,
        EndTime: null,
        ReviewNotice: ''
      },
      // 修改表单
      editForm: {
        StartTime: null
      },
      // 添加表单验证
      addRules: {
        MatchName: [
          {
            required: true,
            message: '请输入赛事名称',
            trigger: 'blur'
          }
        ],
        StartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        RegStartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        RegEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        ScoStartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        ScoEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        EndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ]
      },
      // 修改表单验证
      editRules: {
        MatchName: [
          {
            required: true,
            message: '请输入赛事名称',
            trigger: 'blur'
          }
        ],
        StartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        RegStartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        RegEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        ScoStartTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        ScoEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        EndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ]
      },
      // 评审须知
      noticeForm: {
        ReviewNotice: ''
      },
      noticeRules: {
        notice: [
          {
            required: true,
            message: '请输入评审须知',
            trigger: 'blur'
          }
        ]
      },
      // 导出excel名称
      tableFileName: ''
    }
  },
  created() {
    //   默认获取列表
    this.getCreateList(1)
  },
  methods: {
    starttimeChange(value) {
      console.log(value)
    },
    //   获取赛事列表
    async getCreateList(newPage) {
      this.queryInfo.pageNum = newPage
      const { data: res } = await this.$http.get('/api/Match/GetAllMatchs', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.matchs
      this.total = res.Data.total
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.PageSize = newSize
      this.getCreateList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getCreateList(newPage)
    },
    // 关闭弹窗重置表单验证
    addresetFields() {
      this.$refs.addFormRef.resetFields()
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.$refs.editFormRef.resetFields()
    },
    // 关闭弹窗重置表单验证
    noticeresetFields() {
      this.$refs.noticeFormRef.resetFields()
    },
    // 显示创建赛事弹窗
    showAddCreate() {
      // 打开弹窗
      this.addDialogVisible = true
    },
    // 显示修改赛事弹窗
    showEditCreate(row) {
      this.editForm = {
        MatchID: row.MatchID,
        MatchName: row.MatchName,
        StartTime: this.$moment(row.StartTime).format('YYYY-MM-DD HH:mm:ss'),
        RegStartTime: this.$moment(row.RegStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        RegEndTime: this.$moment(row.RegEndTime).format('YYYY-MM-DD HH:mm:ss'),
        ScoStartTime: this.$moment(row.ScoStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        ScoEndTime: this.$moment(row.ScoEndTime).format('YYYY-MM-DD HH:mm:ss'),
        EndTime: this.$moment(row.EndTime).format('YYYY-MM-DD HH:mm:ss')
      }

      this.editDialogVisible = true
    },
    // 显示修改评审弹窗
    showEditNotice(row) {
      this.noticeForm = row
      this.noticeDialogVisible = true
    },
    // 添加
    addCreate() {
      this.$refs.addFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Match/EditMatch',
          this.addForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.addDialogVisible = false
        // 刷新列表
        this.getCreateList(1)
      })
    },
    // 修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Match/EditMatch',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        this.noticeDialogVisible = false
        // 刷新列表
        this.getCreateList(this.queryInfo.pageNum)
      })
    },
    // 修改评审
    async editNotice() {
      // 发起添加请求
      const { data: res } = await this.$http.post(
        '/api/Match/ModifyReviewNotice',
        this.noticeForm
      )
      // 判断状态码
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      // 成功提示
      this.$message.success(res.Msg)
      // 关闭弹窗
      this.noticeDialogVisible = false
      // 刷新列表
      this.getCreateList(this.queryInfo.pageNum)
    },
    // 删除
    async deleteCreate(id) {
      console.log(id)
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      // 再次提示
      const res2 = await this.$confirm(
        '此操作会删除所有关联数据，删除后无法恢复！请谨慎操作！！！确认删除吗?',
        '警告',
        {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'messageColor'
        }
      ).catch((err) => {
        return err
      })
      if (res2 !== 'confirm') return this.$message.info('已取消删除')

      const { data: resdel } = await this.$http.post(
        '/api/Match/DeleteMatch?matchID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error(res.Msg)
      this.$message.success('删除成功')
      // 刷新列表
      this.getCreateList(this.queryInfo.pageNum)
    },
    // 导出excel
    export2Excel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require('../../../excel/Export2Excel')
        const tHeader = [
          '赛事名称',
          '开始时间',
          '报名开始',
          '报名截止',
          '评分开始',
          '评分截止',
          '结束时间'
        ]
        const filterVal = [
          'MatchName',
          'StartTime',
          'RegStartTime',
          'RegEndTime',
          'ScoStartTime',
          'ScoEndTime',
          'EndTime'
        ]
        const list = this.pagedata
        const data = this.formatJson(filterVal, list)
        const tableFileName = '赛事信息' + this.setTableFileName()
        exportJsonToExcel(tHeader, data, tableFileName)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    setTableFileName() {
      return this.$moment(new Date()).format('YYYYMMDDHHmmss')
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
</style>
